// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "./(OnboardingResult)/HasToeicExamExperience";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "./(OnboardingResult)/TargetExamScore";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        hasToeicExamExperience: undefined,
        targetExamScore: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.hasToeicExamExperience !== undefined)
        result.hasToeicExamExperience = encodeJson_1(value.hasToeicExamExperience);
    if (value.targetExamScore !== undefined)
        result.targetExamScore = encodeJson_2(value.targetExamScore);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.hasToeicExamExperience !== undefined)
        result.hasToeicExamExperience = decodeJson_1(value.hasToeicExamExperience);
    if (value.targetExamScore !== undefined)
        result.targetExamScore = decodeJson_2(value.targetExamScore);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.hasToeicExamExperience !== undefined) {
        const tsValue = value.hasToeicExamExperience;
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.targetExamScore !== undefined) {
        const tsValue = value.targetExamScore;
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.hasToeicExamExperience = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.targetExamScore = value;
    }
    return result;
}
